import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"; // You can also customize this CSS if needed
import dangerIconRed from "../../assets/images/icons/dangerIconRed.svg";
import CalendarIconUniversal from "../../assets/images/icons/CalendarIconUniversal.svg";
import CalendarIcon from "../Icons/CalendarIcon";
// import CalendarIcon from "../../assets/images/calendarIcon.svg";
import { createPortal } from "react-dom";
const DatePickerComponent = ({
  value = null,
  onChange,
  className = "",
  placeholder = "",
  mandatory = false,
  error,
  label = "",
  helperText = "",
  id,
  autoFocus = false,
  minDate = null, // Disable dates before this date
  maxDate = null, // Disable dates after this date
  height = "2.6rem",
  size = "small",
  dateFormat = "dd/MM/yyyy",
  autoOpen = false,
  isTracking,
  noBorder,
  isDisabled,
  innerClassName = "",
  hiddenRef = null,
  boxHidden = false,
  disabled = false,
  ...props
}) => {
  const [touched, setTouched] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [isOpen, setIsOpen] = useState(false); // This controls the open state
  const inputRef = useRef(null); // Reference to the input field

  useEffect(() => {
    setErrorText(error);
  }, [error]);

  console.log(errorText, error, "errorText inside");
  const handleInputBlur = () => {
    setTouched(true);
    // if (!value) {
    //   setErrorText("Please select a date");
    // } else {
    //   setErrorText("");
    // }
  };

  // Automatically focus the input if there's an error or if autoFocus is set
  // useEffect(() => {
  //   if (autoFocus && inputRef.current) {
  //     inputRef.current.focus();
  //   }
  //   if (errorText && inputRef.current) {
  //     inputRef.current.focus(); // Focus on the input when error occurs
  //   }
  // }, [errorText, autoFocus]);

  const handleIconClick = (e) => {
    e.stopPropagation();
    if (isDisabled) return;
    if (inputRef.current) {
      setIsOpen((prev) => !prev);
      // inputRef.current.querySelector("input").click(); // Focus on the input inside the DatePicker
    }
  };

  useEffect(() => {
    // Open on mount or based on some condition
    autoOpen && setIsOpen(true);
  }, []);

  const dynamicClass = () => {
    if (size === "small") {
      return "px-[0.4rem] py-[0.3rem] text-[0.8rem] h-[25px]";
    } else if (size === "medium") {
      return "px-3 py-1 text-[0.9rem] h-[30px]";
    } else if (size === "large") {
      return "px-3 py-1 text-[0.9rem] h-[38px]";
    }
  };

  const dynamicButtonClass = () => {
    if (size === "small") {
      return " p-[0.6rem]";
    } else if (size === "medium") {
      return "";
    } else if (size === "large") {
      return "";
    }
  };

  return (
    <div className={`flex flex-col w-full  ${className} ${boxHidden && "h-0"}`} role="form">
      {label && (
        <label htmlFor={id} className="text-sm font-medium text-gray-700 mb-1" aria-label={label}>
          {label}
        </label>
      )}

      <div className={`${boxHidden && "mt-[-20px]"} relative bg-container-datepicker`} ref={inputRef}>
        <DatePicker
          ref={inputRef}
          selected={value}
          onChange={(date) => {
            onChange(date);
            setIsOpen(false);
          }}
          // onInputClick={() => setIsOpen((prev) => !prev)}
          onFocus={() => setIsOpen(true)}
          onClickOutside={() => setIsOpen(false)}
          placeholderText={placeholder}
          style={{ height }}
          className={`${boxHidden && "hidden h-0"} w-full border rounded-md   ${
            Boolean(mandatory) && helperText && ((touched && !value) || errorText) && !value
              ? "border-[#EF4444] focus:ring-0 focus:ring-[#EF4444] focus:border-[#EF4444]"
              : "border-gray-300 focus:ring-0 focus:border-[#7A7D84]"
          }  ${dynamicClass()} ${noBorder && "border-transparent"} 
          ${isDisabled && "cursor-not-allowed opacity-50 pointer-events-none border-[#dbdbdb] bg-[#d8d8d8]"}
          ${innerClassName} `}
          id={id}
          aria-invalid={errorText ? "true" : "false"}
          aria-describedby={(helperText && touched && !value) || errorText ? `${id}-helper` : undefined}
          {...props}
          dateFormat={dateFormat} // Format the date as per your requirement
          popperPlacement="bottom-end"
          onBlur={handleInputBlur}
          tabIndex={0} // Ensures the input is part of the tab order
          autoFocus={autoFocus} // Focus the input field on page load if required
          minDate={minDate} // Disable dates before `minDate`
          maxDate={maxDate} // Disable dates after `maxDate`.
          popperContainer={({ children }) => createPortal(children, document.getElementById("portal-root"))}
          open={isOpen}
        />
        {!Boolean(boxHidden) && (
          <button
            className={`absolute right-[1px] top-1/2 transform -translate-y-1/2 pr-1 `}
            onClick={handleIconClick}
            type="button"
          >
            <CalendarIcon size={size} isTracking={isTracking} />
          </button>
        )}
      </div>

      {Boolean(mandatory) && helperText && ((touched && !value) || errorText) && !value && (
        <span
          id={`${id}-helper`}
          className="flex gap-1 items-center text-xs text-gray-500 ms-1 text-[#BF2315] text-[10px]"
          role="alert"
          aria-live="assertive"
        >
          <img src={dangerIconRed} className="h-[10px] w-[10px]" alt="Error icon" />
          {helperText || errorText}
        </span>
      )}
    </div>
  );
};

export default DatePickerComponent;
